import moment from 'moment/moment';

export const formatDuration = (seconds: number) => {
  const duration = moment.duration(seconds, 'seconds');

  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();
  const secs = duration.seconds();

  let formattedTime = '';
  if (hours > 0) {
    formattedTime += `${hours}h `;
  }
  if (minutes > 0) {
    formattedTime += `${minutes}m `;
  }
  if (secs > 0) {
    formattedTime += `${secs}s`;
  }

  return formattedTime.trim();
};
